import StandaloneChatPDF from './pdfcontrols/StandaloneChatPDF';

const CreatePDFView = () => {
  return <StandaloneChatPDF />;
};

export default CreatePDFView;
